<!-- <div class="loading">
  <img src="./assets/images/loading.svg" alt="Loading..." />
</div> -->
<div class="progress-full-loader" >  
  <mat-progress-spinner [mode]="'indeterminate'">
  </mat-progress-spinner>
</div>